<template>
  <div>
    <navbar>
      <template #before>
        <router-link to="/admin/products" class="btn btn-sm btn-outline-light">
          Back
        </router-link>
      </template>
      <template #title>
        <span class="text-light">Admin » Products</span>
      </template>
    </navbar>
    <container>
      <hr class="border-top" />
      <form
        @submit.prevent="submit"
        enctype="multipart/form-data"
        method="post"
      >
        <!-- Product -->
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <h3 class="fw-light">Product</h3>
          </div>
          <div class="col-12 col-md-8">
            <div class="shadow-sm px-3 pt-3 card">
              <div class="mb-3">
                <label for="ProductName">Product</label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="data.Product.name"
                  id="ProductName"
                />
              </div>
              <div class="mb-3">
                <label for="ProductName">Code</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.code"
                  id="ProductName"
                />
              </div>
              <div class="mb-3">
                <label for="ProductManufacturer">Manufacturer</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.manufacturer.name"
                  id="ProductManufacturer"
                  list="ProductManufacturers"
                />
                <datalist id="ProductManufacturers">
                  <option
                    v-for="item of manufacturers"
                    :value="item.name"
                    :key="item.id"
                  ></option>
                </datalist>
              </div>
              <div class="mb-3">
                <label for="ProductVendor">Vendor</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.vendor.name"
                  id="ProductVendor"
                  list="ProductVendors"
                />
                <datalist id="ProductVendors">
                  <option
                    v-for="item of vendors"
                    :value="item.name"
                    :key="item.id"
                  ></option>
                </datalist>
              </div>
            </div>
          </div>
        </div>

        <hr class="border-top" />
        <!-- Local -->
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <h3 class="fw-light">Local Information</h3>
          </div>
          <div class="col-12 col-md-8">
            <div class="shadow-sm px-3 pt-3 card">
              <div class="mb-3">
                <label for="ProductLocalName">Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.local_name"
                  id="ProductLocalName"
                />
              </div>
              <div class="mb-3">
                <label for="ProductLocalId">ID</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.local_id"
                  id="ProductLocalId"
                />
              </div>
              <div class="mb-3">
                <label for="ProductLocation">Location</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.Product.location.name"
                  id="ProductLocation"
                  list="ProductLocations"
                />
                <datalist id="ProductLocations">
                  <option
                    v-for="item of locations"
                    :value="item.name"
                    :key="item.id"
                  ></option>
                </datalist>
              </div>
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  v-model="data.Product.is_active"
                  class="form-check-input"
                  id="ProductIsActive"
                />
                <label class="form-check-label" for="ProductIsActive">
                  Product is in use
                </label>
              </div>
            </div>
          </div>
        </div>
        <hr class="border-top" />

        <!-- Safety Data Sheet -->
        <div class="row my-3">
          <div class="col-12 col-md-4">
            <h3 class="fw-light">Safety Data Sheet</h3>
          </div>
          <div class="col-12 col-md-8">
            <div class="shadow-sm px-3 pt-3 card">
              <div class="mb-3">
                <label for="ProductSdsNumber">Number</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Number"
                  v-model="data.Product.sds_number"
                  id="ProductSdsNumber"
                />
              </div>
              <div class="mb-3">
                <label for="ProductSdsDate">Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.Product.sds_date"
                  id="ProductSdsDate"
                />
              </div>
              <div class="mb-3">
                <label for="ProductSdsVersion">Version</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Version"
                  v-model="data.Product.sds_version"
                  id="ProductSdsVersion"
                />
              </div>
              <div class="mb-3">
                <label for="ProductSdsFile">File</label>
                <input
                  type="file"
                  class="form-control"
                  ref="ProductSdsFile"
                  id="ProductSdsFile"
                  accept=".pdf"
                />
              </div>
              <div class="mb-3">
                <label for="ProductSignalWord">Signal Word</label>
                <select
                  v-model="data.Product.signal_word"
                  class="form-select"
                  id="ProductSignalWord"
                >
                  <option></option>
                  <option value="none">None</option>
                  <option value="warning">Warning</option>
                  <option value="danger">Danger</option>
                </select>
              </div>
              <div class="mb-3 row">
                <div class="col">
                  <label for="ProductBlue">Blue</label>
                  <input
                    min="0"
                    max="6"
                    type="number"
                    class="form-control"
                    v-model="data.Product.blue"
                    id="ProductBlue"
                  />
                  <div class="form-check mt-2">
                    <input
                      type="checkbox"
                      v-model="data.Product.is_chronic"
                      class="form-check-input"
                      id="ProductIsChronic"
                    />
                    <label class="form-check-label" for="ProductIsChronic">
                      Chronic
                    </label>
                  </div>
                </div>
                <div class="col">
                  <label for="ProductRed">Red</label>
                  <input
                    min="0"
                    max="6"
                    type="number"
                    class="form-control"
                    v-model="data.Product.red"
                    id="ProductRed"
                  />
                </div>
                <div class="col">
                  <label for="ProductOrange">Orange</label>
                  <input
                    min="0"
                    max="6"
                    type="number"
                    class="form-control"
                    v-model="data.Product.orange"
                    id="ProductOrange"
                  />
                </div>
                <div class="col">
                  <label for="ProductYellow">Yellow</label>
                  <input
                    min="0"
                    max="6"
                    type="number"
                    class="form-control"
                    v-model="data.Product.yellow"
                    id="ProductYellow"
                  />
                </div>
              </div>
              <div class="mb-3">
                <label>
                  Globally Harmonized System (GHS) Hazard Pictograms
                </label>
                <div class="row gx-1">
                  <div
                    v-for="hazard of hazards"
                    :key="hazard.id"
                    class="col-4 d-flex mb-3"
                  >
                    <!-- <div class="img-thumbnail"> -->
                    <div class="mx-auto">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="data.Product.hazards"
                          :value="hazard"
                          :id="`ProductHazard${hazard.id}`"
                        />
                        <label
                          class="form-check-label"
                          :for="`ProductHazard${hazard.id}`"
                        >
                          <img
                            :src="`/img/ems/ghs-${hazard.id}.svg`"
                            :title="`${hazard.name}`"
                            :alt="`${hazard.description}`"
                            class="img-thumbnail border-0"
                            width="60"
                            height="60"
                          />
                        </label>
                      </div>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label>
                  Globally Harmonized System (GHS) Hazard Statements
                </label>
                <div class="row gx-1">
                  <vue-select
                    label="code"
                    v-model="data.Product.hazard_statements"
                    :options="hazardStatements"
                    :filterBy="hazardStatementFilterBy"
                    :multiple="true"
                  >
                    <template #option="{ code, description }">
                      <div>
                        <code v-text="code"></code>
                        &nbsp;
                        <span v-text="description"></span>
                      </div>
                    </template>
                    <template #selected-option="{ code, description }">
                      <div>
                        <code v-text="code"></code>
                        &nbsp;
                        <span v-text="description"></span>
                      </div>
                    </template>
                  </vue-select>
                </div>
                <!-- <ul>
                  <li v-for="hs of data.Product.hazard_statements" :key="hs.id">
                    <code v-text="hs.code"></code> |
                    <span v-text="hs.description"></span>
                  </li>
                </ul> -->
              </div>
            </div>
          </div>
        </div>
        <hr class="border-top" />

        <!-- Environmental Data Sheet -->
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <h3 class="fw-light">Environmental Data Sheet</h3>
          </div>
          <div class="col-12 col-md-8">
            <div class="shadow-sm px-3 pt-3 card">
              <div class="mb-3">
                <label for="ProductEdsDate">Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.Product.eds_date"
                  id="ProductEdsDate"
                />
              </div>
              <div class="mb-3">
                <label for="ProductEdsVersion">Version</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Version"
                  v-model="data.Product.eds_version"
                  id="ProductEdsVersion"
                />
              </div>
              <div class="mb-3">
                <label for="ProductEdsFile">File</label>
                <input
                  type="file"
                  class="form-control"
                  ref="ProductEdsFile"
                  id="ProductEdsFile"
                  accept=".pdf"
                />
              </div>
            </div>
          </div>
        </div>
        <hr class="border-top" />

        <!-- Action Tray -->
        <div class="mb-3 text-end">
          <button class="btn btn-primary" type="submit">Save</button>
        </div>
      </form>
    </container>
  </div>
</template>
<script>
import VueSelect from "vue-select";
import he from "he";
export default {
  components: { VueSelect },
  name: "AdminProductsCreate",
  data: () => ({
    data: {
      Product: {
        name: null,
        manufacturer: {
          name: null
        },
        vendor: {
          name: null
        },
        type: {
          name: null
        },
        location: {
          name: null
        },
        local_name: null,
        local_id: null,
        is_active: true,
        sds_number: null,
        blue: 0,
        red: 0,
        orange: 0,
        yellow: 0,
        is_chronic: false,
        sds_date: null,
        sds_version: null,
        signal_word: null,
        eds_date: null,
        eds_version: null,
        hazards: [],
        hazard_statements: []
      }
    },
    vendors: [],
    manufacturers: [],
    locations: [],
    hazards: [],
    hazardStatements: []
  }),
  computed: {
    postUrl() {
      return this.$route.params.id
        ? `/api/products/edit/${this.$route.params.id}.json?v=${Date.now()}`
        : `/api/products/add.json?v=${Date.now()}`;
    }
  },
  methods: {
    async load() {
      const timestamp = Date.now();
      const vendors = await this.axios.get(`/api/vendors.json?v=${timestamp}`);
      const manufacturers = this.axios.get(
        `/api/manufacturers.json?v=${timestamp}`
      );
      const locations = await this.axios.get(
        `/api/locations.json?v=${timestamp}`
      );
      const hazards = await this.axios.get(`/api/hazards.json?v=${timestamp}`);
      const hazardStatements = await this.axios.get(
        `/api/hazard-statements.json?v=${timestamp}`
      );

      this.vendors = vendors.data;
      this.manufacturers = manufacturers.data;
      this.locations = locations.data;
      this.hazards = hazards.data;
      this.hazardStatements = hazardStatements.data;

      if (this.$route.params.id) {
        const product = await this.axios.get(
          `/api/products/get/${this.$route.params.id}.json?v=${timestamp}`
        );
        product.data.name = he.decode(product.data.name);
        product.data.code = he.decode(product.data.code);
        product.data.local_name = he.decode(product.data.local_name);

        this.data.Product = product.data;
      }
    },
    submit() {
      const formData = new FormData();

      let product = this.data.Product;
      product.name = he.encode(product.name);
      product.code = he.encode(product.code);
      product.local_name = he.encode(product.local_name);

      formData.append("data", JSON.stringify(product));

      if (this.$refs.ProductSdsFile.files.length) {
        formData.append("sds", this.$refs.ProductSdsFile.files[0]);
      }
      if (this.$refs.ProductEdsFile.files.length) {
        formData.append("eds", this.$refs.ProductEdsFile.files[0]);
      }

      this.axios
        .post(this.postUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.$router.push("/admin/products");
        });
    },
    hazardStatementFilterBy(option, label, search) {
      return JSON.stringify(Object.values(option))
        .toLowerCase()
        .includes(search.toLowerCase());
    }
  },
  mounted() {
    this.load();
  }
};
</script>
<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.vs__selected-options {
  flex-direction: column;
}
.vs__selected {
  justify-content: space-between;
}
</style>
